"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentGroup = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.SegmentGroup = (0, styled_1.default)('div') `
  display: inline-flex;
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  & button:not(:first-of-type) {
    margin-left: -${(0, ui_theme_1.fromTheme)('border_width')};
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
  & button:not(:last-of-type) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  ${(_a) => {
    var { variant } = _a, props = __rest(_a, ["variant"]);
    return variant === 'rounded'
        ? `& button:first-of-type {
        border-bottom-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')(props)};
        border-top-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')(props)};
      }
      & button:last-of-type {
        border-bottom-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')(props)};
        border-top-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')(props)};
      }`
        : '';
}};
`;
//# sourceMappingURL=SegmentedGroup.styles.js.map